// // StatusPicker.js
// import React, { useState } from "react";
// import { useSelector } from "react-redux"; 
// import { AiOutlineDown } from "react-icons/ai";
// import '../../assets/styles/status-picker.css'; // Asegúrate de que los estilos están importados
// import { ROLES } from '../../services/user.service'; // Asegúrate de importar correctamente
// import NotificationModal from '../modal/notifications-modal'; // Importa el componente del modal


// export function StatusPicker({ customHeight, info, field, onUpdate, userRol }) {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedStatus, setSelectedStatus] = useState(info.estado);
//     const [modalOpen, setModalOpen] = useState(false); // Estado para el modal
//     const [modalMessage, setModalMessage] = useState('');
//     const [modalType, setModalType] = useState('info'); // Tipo de alertazz

//     const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
//   const statusOptions = DataInfo?.statusOptions?.map(option => ({
//     id: option.id_estado_actividad,
//     name: option.descripcion,
//     color: option.color,
//     textColor: option.textcolor,
//   })) || [];

//     // Definir si el usuario puede editar
//     const isEditable = userRol === ROLES.ADMIN || userRol === ROLES.TECNICO;

    
    
//     function handleStatusChange(ev, status) {
//         ev.preventDefault();
//         if (!isEditable) return; // Si no es editable, no hacer nada
    
//         // Obtener la opción seleccionada
//         const selectedOption = statusOptions.find(opt => opt.id === status);
//         if (!selectedOption) return; // Si no existe la opción seleccionada, salir
        
//         if (info.campo === "task-preview") {

//         // Eliminar espacios en blanco de la descripción de avances
//         const avancesDescripcion = info.avancesDescripcion?.trim() || '';
    
//         // Definir mensajes de advertencia
//         const emptyDescriptionMessage = "No es posible modificar el estado de la ACTIVIDAD si el campo DESCRIPCIÓN DE AVANCES está vacío. Por favor, complete la descripción para proceder con la actualización del estado (Mínimo 30 caracteres)";
//         const noFilesMessage = "No se puede modificar el estado de la ACTIVIDAD, mientras no haya archivos adjuntos.";
    
//         // Validación de estado y descripción de avances
//         const isRestrictedStatus = ["Terminada", "En proceso", "No se Realizara"].includes(selectedOption.name);
//         if (isRestrictedStatus && avancesDescripcion.length < 50) {
//             setModalMessage(emptyDescriptionMessage);
//             setModalType("warning");
//             setModalOpen(true);
//             return; // Detener la ejecución si no cumple la validación
//         }
    
//         // Validación de cantidad de archivos (excepto si es "No se realizara")
//         if (info.cantidadArchivos === 0 && selectedOption.name === "Terminada") {
//             setModalMessage(noFilesMessage);
//             setModalType("warning");
//             setModalOpen(true);
//             return; // Detener la ejecución si no cumple la validación
//         }
//     }

//         setSelectedStatus(status);
//         setIsOpen(false);
//         onSave(ev, status);


        
//     }

//     function onSave(ev, status) {
//         onUpdate(ev, field, status);
//     }

//     const selectedOption = statusOptions.find(opt => opt.id === selectedStatus);

//     return (
//         <div className="status-picker picker" style={{alignContent:'center', height: customHeight, width:'170px'}}>
//             <div 
//                 className="selected-status" 
//                 onClick={() => isEditable && setIsOpen(!isOpen)} // Solo abrir si es editable
//                 style={{ 
//                     backgroundColor: selectedOption?.color || '#ffffff', 
//                     color: selectedOption?.textColor || '#ffffff', 
//                     height: customHeight,
//                     cursor: isEditable ? 'pointer' : 'not-allowed' // Cambiar el cursor según si es editable
//                 }}
//             >
//                 {selectedOption?.name || "Seleccionar..."}
//                 <AiOutlineDown className="dropdown-icon" />
//             </div>
//             {isOpen && (
//                 <ul className="status-options">
//                     {statusOptions.map(option => (
//                         <li 
//                             key={option.id} 
//                             onClick={(ev) => handleStatusChange(ev, option.id)} 
//                             className={option.id === selectedStatus ? "selected" : ""}
//                             style={{ backgroundColor: option.color, color: option.textColor }}
//                         >
//                             {option.name}
//                         </li>
//                     ))}
//                 </ul>
//             )}
//             <NotificationModal open={modalOpen} onClose={() => setModalOpen(false)} message={modalMessage} type={modalType}/>
//         </div>
//     );
// }


import React, { useState } from "react";
import { useSelector } from "react-redux";
import { AiOutlineDown } from "react-icons/ai";
import '../../assets/styles/status-picker.css'; 
import { ROLES } from '../../services/user.service';
import NotificationModal from '../modal/notifications-modal';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export function StatusPicker({ customHeight, info, field, onUpdate, userRol }) {
    const [selectedStatus, setSelectedStatus] = useState(info.estado);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('info');
    const [anchorEl, setAnchorEl] = useState(null);

    const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
    const statusOptions = DataInfo?.statusOptions?.map(option => ({
        id: option.id_estado_actividad,
        name: option.descripcion,
        color: option.color,
        textColor: option.textcolor,
    })) || [];

    const isEditable = userRol === ROLES.ADMIN || userRol === ROLES.TECNICO;

    function handleStatusChange(ev, status) {
        ev.preventDefault();
        if (!isEditable) return;

        const selectedOption = statusOptions.find(opt => opt.id === status);
        if (!selectedOption) return;

        // Validaciones específicas para "task-preview"
        if (info.campo === "task-preview") {
            const avancesDescripcion = info.avancesDescripcion?.trim() || '';
            const emptyDescriptionMessage = "No es posible modificar el estado de la ACTIVIDAD si el campo DESCRIPCIÓN DE AVANCES está vacío. Por favor, complete la descripción para proceder con la actualización del estado (Mínimo 30 caracteres).";
            const noFilesMessage = "No es posible modificar el estado de la ACTIVIDAD si no se han adjuntado archivos. Por favor, adjunte los archivos necesarios para proceder con la actualización del estado.";

            if (["Terminada", "En proceso", "No se Realizara"].includes(selectedOption.name) && avancesDescripcion.length < 30) {
                setModalMessage(emptyDescriptionMessage);
                setModalType("warning");
                setModalOpen(true);
                return; // Detener si no cumple la validación
            }

            if (info.cantidadArchivos === 0 && selectedOption.name === "Terminada") {
                setModalMessage(noFilesMessage);
                setModalType("warning");
                setModalOpen(true);
                return;
            }
        }

        setSelectedStatus(status);
        setAnchorEl(null); // Cierra el menú
        onSave(ev, status);
    }

    function onSave(ev, status) {
        onUpdate(ev, field, status);
    }

    const selectedOption = statusOptions.find(opt => opt.id === selectedStatus);

    return (
        <div 
            className="status-picker picker" 
            style={{ alignContent: 'center', height: customHeight, width: '170px' }}
        >
            <div
                className="selected-status"
                onClick={(event) => isEditable && setAnchorEl(event.currentTarget)}
                style={{
                    backgroundColor: selectedOption?.color || '#ffffff',
                    color: selectedOption?.textColor || '#ffffff',
                    height: customHeight,
                    cursor: isEditable ? 'pointer' : 'not-allowed',
                }}
            >
                {selectedOption?.name || "Seleccionar..."}
                <AiOutlineDown className="dropdown-icon" />
            </div>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                    style: {
                        maxHeight: 300,
                        width: '171px',
                    },
                }}
            >
                {statusOptions.map(option => (
                    <MenuItem
                        key={option.id}
                        onClick={(ev) => handleStatusChange(ev, option.id)}
                        style={{
                            backgroundColor: option.color,
                            color: option.textColor,
                            fontSize: "14px",
                            fontWeight: option.id === selectedStatus ? 'bold' : 'normal',
                        }}
                    >
                        {option.name}
                    </MenuItem>
                ))}
            </Menu>
            <NotificationModal 
                open={modalOpen} 
                onClose={() => setModalOpen(false)} 
                message={modalMessage} 
                type={modalType} 
            />
        </div>
    );
}
